import { Box, Stack } from "@mui/material";
import { isEmpty } from "lodash-es";

import FileListView from "@/common/components/Files/FileListView";
import FieldValue from "@/common/components/Form/Display/FieldValue";
import { ATTACHMENTS_COMMON_ITEM_SIZES } from "@/common/constants/common";
import { FileItem } from "@/common/fileItem";
import { DamageDetectionDto, DamageDetectionItemDto } from "@/core/api/generated/v1";

import VehicleDamageLink from "../VehicleDamage/VehicleDamageLink";
import { VisualModelViewerOfDamageDetectionItem } from "../VehicleVisualModel/Viewer/v2/Entity/VisualModelViewerOfDamageDetectionItem";

export interface DamageDetectionItemViewProps {
  damageDetection: DamageDetectionDto;
  item: DamageDetectionItemDto;
}

export function DamageDetectionItemView({ damageDetection, item }: DamageDetectionItemViewProps) {
  return (
    <Box>
      <Stack direction='column' spacing={1}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xxs: "1fr",
              lg: "2fr 2fr",
            },
            columnGap: 2,
            rowGap: 2,
          }}
        >
          <Stack spacing={1}>
            {/* {item?.localNumber && <FieldValue label='Local number'>{item?.localNumber}</FieldValue>} */}
            <FieldValue label='Part type'>{item?.partType?.name}</FieldValue>
            <FieldValue label='Damage type'>{item?.damageType?.name}</FieldValue>
            <FieldValue label='Area'>{item?.area}</FieldValue>
            <FieldValue label='Projection'>{item?.projection}</FieldValue>

            {item?.damage?.id && (
              <FieldValue label='Damage' isEmpty={!item?.damage?.id}>
                <VehicleDamageLink
                  vehicleId={item?.damage?.vehicleId}
                  entityId={item?.damage?.id}
                  entity={item?.damage}
                />
              </FieldValue>
            )}

            {item?.notes && (
              <FieldValue label='Notes' isEmpty={!item?.notes}>
                {item?.notes}
              </FieldValue>
            )}
            {!isEmpty(item?.attachments) && (
              <Box sx={{ mt: 2 }}>
                <FileListView
                  files={FileItem.createManyFrom(item?.attachments)}
                  maxVisibleFiles={10}
                  itemWidth={ATTACHMENTS_COMMON_ITEM_SIZES.WIDTH}
                  itemHeight={ATTACHMENTS_COMMON_ITEM_SIZES.HEIGHT}
                />
              </Box>
            )}
          </Stack>

          {/* Visual model */}
          <Stack spacing={1} sx={{ overflow: "hidden" }}>
            {/* <Typography variant='h2'>Visual model</Typography> */}

            <VisualModelViewerOfDamageDetectionItem
              damageDetection={damageDetection}
              item={item}
              visualModelSvgViewerProps={{
                svgViewerProps: {
                  svgProps: {
                    width: 400,
                    height: 400,
                    minWidth: 200,
                    minHeight: 200,
                    maxWidth: 500,
                    maxHeight: 500,
                    cursor: "default",
                    point: {
                      cursor: "default",
                    },
                  },
                },
              }}
            />
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
}
